import { FormattedMessage } from 'react-intl';

import { People, AddCircle,Calendar,ProfileAdd } from 'iconsax-react';

import { NavItemType } from 'types/menu';

const icons = { icon1: People, addIcon: AddCircle,calendar: Calendar,profile:ProfileAdd };

const attendance: NavItemType = {
  id: 'attendance',
  type: 'group',
  icon: icons.icon1,
  name: 'Attendance',
  children: [
      {
        icon: icons.icon1,
        id: 'attendance',
        title: <FormattedMessage id="Attendance" />,
        type: 'collapse',
        children: [
          {
              icon: icons.profile,
              id: 'attendance',
              title: <FormattedMessage id="Add Attendance" />,
              type: 'item',
              name: 'Attendance',
              url: '/attendance'
          },
          {
            icon: icons.calendar,
            id: 'attendanceReport',
            title: <FormattedMessage id="Attendance Report" />,
            type: 'item',
            name: 'AttendanceReport',
            url: '/attendance/attendanceReport'
          },
        ]
      }
    ]
};

export default attendance;
